import React from "react";

// components
import SiteHeader from "core/SiteHeader";

// SiteHeaderParent is used on all NEW pages.
const SiteHeaderParent = () => {
    return <SiteHeader />;
};

export default SiteHeaderParent;
